import React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "reactstrap";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMBER, PATTERN_NUMERIC_ARRAY_6DOF } from "src/constant/common";

const VehicleSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.vehicle_sigma_title")}</h3>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.DRY_MASS}`)}
          name={`MCS.${FORM_NAME.MCS.DRY_MASS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.DRY_MASS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.DRY_MASS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.DRY_MASS}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.DRY_MASS}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.DRY_MASS}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TOTAL_MASS}`)}
          name={`MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TOTAL_MASS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TOTAL_MASS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.CENTER_OF_GRAVITY_TOTAL_MASS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TOTAL_MASS}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TOTAL_MASS}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TOTAL_MASS}`) }),
          }}
          unit="x, y, z) (m"
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_DRY_MASS}`)}
          name={`MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_DRY_MASS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_DRY_MASS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.CENTER_OF_GRAVITY_DRY_MASS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_DRY_MASS}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_DRY_MASS}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_DRY_MASS}`) }),
          }}
          unit="x, y, z) (m"
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TANK}`)}
          name={`MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TANK}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TANK}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.CENTER_OF_GRAVITY_TANK]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TANK}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TANK}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.CENTER_OF_GRAVITY_TANK}`) }),
          }}
          unit="x, y, z) (m"
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_TOTAL_MASS}`)}
          name={`MCS.${FORM_NAME.MCS.FUEL_POSITION_TOTAL_MASS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_TOTAL_MASS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.FUEL_POSITION_TOTAL_MASS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_TOTAL_MASS}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_TOTAL_MASS}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_TOTAL_MASS}`) }),
          }}
          unit="x, y, z) (m"
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_DRY_MASS}`)}
          name={`MCS.${FORM_NAME.MCS.FUEL_POSITION_DRY_MASS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_DRY_MASS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.FUEL_POSITION_DRY_MASS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_DRY_MASS}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_DRY_MASS}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_POSITION_DRY_MASS}`) }),
          }}
          unit="x, y, z) (m"
        />
      </div>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.PROPELLANT_MASS}`)}
          name={`MCS.${FORM_NAME.MCS.PROPELLANT_MASS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.PROPELLANT_MASS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.PROPELLANT_MASS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.PROPELLANT_MASS}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.PROPELLANT_MASS}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.PROPELLANT_MASS}`) })}
        />
        <div className="form-group position-relative ms-2">
          <Label for={`MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS_X}`} className="position-relative required-input">
            {t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`)} (x, y, z) (kgm&sup2;)
          </Label>
          <FormInput
            register={register}
            type="number"
            name={`MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS_X}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            classInput="width-by-percent-80"
            errors={errors?.MCS?.[FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS_X]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            required
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            pattern={{
              value: PATTERN_NUMERIC_ARRAY_6DOF,
              message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) }),
            }}
          />
          <FormInput
            register={register}
            type="number"
            name={`MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS_Y}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            classInput="width-by-percent-80"
            errors={errors?.MCS?.[FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS_Y]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            required
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            pattern={{
              value: PATTERN_NUMERIC_ARRAY_6DOF,
              message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) }),
            }}
          />
          <FormInput
            register={register}
            type="number"
            name={`MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS_Z}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            classInput="width-by-percent-80"
            errors={errors?.MCS?.[FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS_Z]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            required
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) })}
            pattern={{
              value: PATTERN_NUMERIC_ARRAY_6DOF,
              message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_TOTAL_MASS}`) }),
            }}
          />
        </div>
        <div className="form-group position-relative ms-2">
          <Label for={`MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS_X}`} className="position-relative required-input">
            {t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`)} (x, y, z) (kgm&sup2;)
          </Label>
          <FormInput
            register={register}
            type="number"
            name={`MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS_X}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            classInput="width-by-percent-80"
            errors={errors?.MCS?.[FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS_X]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            required
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            pattern={{
              value: PATTERN_NUMERIC_ARRAY_6DOF,
              message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) }),
            }}
          />
          <FormInput
            register={register}
            type="number"
            name={`MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS_Y}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            classInput="width-by-percent-80"
            errors={errors?.MCS?.[FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS_Y]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            required
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            pattern={{
              value: PATTERN_NUMERIC_ARRAY_6DOF,
              message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) }),
            }}
          />
          <FormInput
            register={register}
            type="number"
            name={`MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS_Z}`}
            placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            classInput="width-by-percent-80"
            errors={errors?.MCS?.[FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS_Z]?.message}
            requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            required
            maxLength={255}
            maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) })}
            pattern={{
              value: PATTERN_NUMERIC_ARRAY_6DOF,
              message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.MOMENT_OF_INERTIA_DRY_MASS}`) }),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default VehicleSigma;
